import { ReactElement } from 'react'

declare global {
  interface Window {
    _klOnsite?: unknown[]
  }
}

export type KlaviyoFormModalProps = {
  /** Klaviyo popup form id opened by the trigger. */
  formId?: string
  renderTrigger?: (action: { click: () => void }) => ReactElement
}

/**
 * Trigger for a Klaviyo popup-type form. `openForm` tells klaviyo.js to show
 * the form in its own overlay, bypassing the form's display triggers. The
 * form must be popup/flyout type — `openForm` is a no-op for embed-type
 * forms, and klaviyo.js never renders embed containers mounted after its
 * initial document scan, which is why this is not a React modal wrapping an
 * embed.
 */
export const KlaviyoFormModal = ({
  formId,
  renderTrigger,
}: KlaviyoFormModalProps) => {
  if (!formId || !renderTrigger) return null

  const open = () => {
    window._klOnsite = window._klOnsite || []
    window._klOnsite.push(['openForm', formId])
  }

  return renderTrigger({ click: open })
}
